import { handleActions } from 'redux-actions';
import { setTOCExpandAll } from 'store/actions/TOC-actions';

export default handleActions(
  {
    [setTOCExpandAll]: (tab, { payload }) => {
      return payload;
    },
  },
  null,
);
